import { useState, useEffect } from "react";

import { usePostPatientSetupIntentsHook } from "api-client";
import { toast } from "react-toastify";

export const useSetIntents = () => {
  const [clientSecret, setClientSecret] = useState<undefined | string>();
  const patientSetupIntents = usePostPatientSetupIntentsHook();

  useEffect(() => {
    const fetchSetupIntents = async () => {
      try {
        const res = await patientSetupIntents();
        setClientSecret(res.clientSecret);
      } catch (e: any) {
        toast.error(e.response.data.message);
      }
    };
    fetchSetupIntents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    clientSecret,
  };
};
